import React from 'react';
import { Mail, Phone, Calendar, Linkedin, Twitter, Instagram, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const handleContact = (type) => {
    if (type === 'email') {
      window.location.href = 'mailto:digitalcoachshyam@gmail.com';
    } else if (type === 'phone') {
      window.location.href = 'tel:+919867809539';
    } else if (type === 'calendar') {
      window.open('https://calendly.com/digitalcoachshyam/startegy-call', '_blank');
    } else if (type === 'whatsapp') {
      const message = encodeURIComponent('Hi! I came across your Digital Shyaam website and would like to discuss my marketing needs.');
      window.open(`https://wa.me/919867809539?text=${message}`, '_blank');
    }
  };

  return (
    <footer className="bg-black text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold" style={{ fontFamily: "'Crimson Text', serif" }}>
              Digital Shyaam
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Growth & Performance Marketing Expert helping businesses scale through data-driven digital strategies.
            </p>
            <div className="flex gap-4">
              <button className="w-10 h-10 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-full flex items-center justify-center transition-all duration-200">
                <Linkedin className="h-5 w-5" />
              </button>
              <button className="w-10 h-10 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-full flex items-center justify-center transition-all duration-200">
                <Twitter className="h-5 w-5" />
              </button>
              <button className="w-10 h-10 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-full flex items-center justify-center transition-all duration-200">
                <Instagram className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Services Column */}
          <div className="space-y-6">
            <h4 className="text-xl font-semibold" style={{ fontFamily: "'Crimson Text', serif" }}>
              Services
            </h4>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">Meta Ads Management</li>
              <li className="hover:text-white transition-colors cursor-pointer">Google Ads Management</li>
              <li className="hover:text-white transition-colors cursor-pointer">Landing Page Creation</li>
              <li className="hover:text-white transition-colors cursor-pointer">Marketing Consulting</li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="space-y-6">
            <h4 className="text-xl font-semibold" style={{ fontFamily: "'Crimson Text', serif" }}>
              Get in Touch
            </h4>
            <div className="space-y-4">
              <button 
                onClick={() => handleContact('email')}
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
              >
                <Mail className="h-5 w-5" />
                <span>digitalcoachshyam@gmail.com</span>
              </button>
              <button 
                onClick={() => handleContact('phone')}
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
              >
                <Phone className="h-5 w-5" />
                <span>+91 98678 09539</span>
              </button>
              <button 
                onClick={() => handleContact('whatsapp')}
                className="flex items-center gap-3 text-gray-400 hover:text-[#25D366] transition-colors"
              >
                <MessageCircle className="h-5 w-5" />
                <span>WhatsApp Chat</span>
              </button>
            </div>
            <Button 
              onClick={() => handleContact('calendar')}
              className="bg-[#ECEC75] text-black hover:bg-[#e6e67c] px-6 py-3 font-semibold rounded-lg transition-all duration-200 w-full"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Book Consultation
            </Button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Digital Shyaam. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <button className="hover:text-white transition-colors">Privacy Policy</button>
              <button className="hover:text-white transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
